import { useState } from "react";
import { Map } from "@vis.gl/react-google-maps";
import Button from "../components/Button";
import { ReactComponent as IconArrow } from "../img/icons/arrow-right.svg";
import { ReactComponent as OrientationHelper } from "../img/orientation_helper.svg";
import { ReactComponent as OrientationHelperLegend } from "../img/orientation_helper_legend.svg";

import getOffset from "../helpers/getOffset";

import useIncrementSimulationStep from "../hooks/useIncrementSimulationStep";

const orientationNames = {
  '0': 'Sud',
  '1': 'Sud-Ouest',
  '-1': 'Sud-Est',
  '2': 'Ouest',
  '-2': 'Est',
  '3': 'Nord-Ouest',
  '-3': 'Nord-Est',
  '4': 'Nord',
  '-4': 'Nord'
};

const orientationDesc = {
  '0': '<span>☀️ <b>Exposition SUD</b></span>✅ Excellente orientation ! Votre toiture est parfaitement exposée pour maximiser le rendement solaire.',
  '1': '<span>☀️ <b>Exposition OUEST</b></span>✅ Orientation acceptable. Le rendement sera un peu inférieur à une orientation plein sud (jusqu\'à moins 20%), mais reste intéressant selon la pente et l\'ensoleillement local.',
  '-1': '<span>☀️ <b>Exposition EST</b></span>✅ Orientation acceptable. Le rendement sera un peu inférieur à une orientation plein sud (jusqu\'à moins 20%), mais reste intéressant selon la pente et l\'ensoleillement local.',
  '2': '<span>☀️ <b>Exposition NORD</b></span>❌ Orientation non compatible. Une toiture orientée plein nord ne permet pas une production solaire efficace.',
  '-2': '<span>☀️ <b>Exposition NORD</b></span>❌ Orientation non compatible. Une toiture orientée plein nord ne permet pas une production solaire efficace.',
};

const OrientationStep = () => {
  const {simParams, incrementSimulationStep} = useIncrementSimulationStep();
  const [interacted, setInteracted] = useState(false);
  const [orientation, setOrientation] = useState(0);
  var angle = null, start_angle = null, da1 = null, da2 = null;
  var dragging = false;

  const dragStart = (evt) => {
    dragging = true; 
    start_angle = null;
  };

  const dragEnd = (evt) => {
    dragging = false;
    setOrientation(angle - start_angle + orientation);
    setInteracted(true);
  };

  const dragHandler = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    if (!dragging) return;

    const playground = document.querySelector('.content .left');
    const off = getOffset(playground);
    const pos = evt.type === 'touchmove' ?
      {x: evt.changedTouches[0].clientX - off.x, y: evt.changedTouches[0].clientY - off.y } :
      {x: evt.clientX - off.x, y: evt.clientY - off.y };

    const dCenterX = (playground.clientWidth + 1)/2;
    const dCenterY = (playground.clientHeight + 1)/2;
    const dDeltaX = pos.x - dCenterX;
    const dDeltaY = pos.y - dCenterY;
    const helper = document.getElementById('orientation_helper');
    angle = ((Math.atan2(dDeltaY, dDeltaX) * 180) / Math.PI);
    if (!start_angle)
      start_angle = angle;
    const cur_angle = (angle - start_angle) + orientation;
    helper.setAttribute('transform', 'rotate(' + cur_angle + ',129,129)');

    if (da1 !== Math.round(cur_angle / 45))
    {
      da1 = Math.round(cur_angle / 45);
      document.getElementById('txt_orientation').innerHTML = orientationNames[da1];
      document.getElementById('bubble_orientation').style.display = 'block';
    }
    if (da2 !== Math.round(cur_angle / 90))
    {
      da2 = Math.round(cur_angle / 90);
      const node = document.getElementById('bubble_explanations');
      node.innerHTML = orientationDesc[da2];
      node.style.display = 'block';
    }
  };

  const validateOrientation = () => {
    if (interacted)
      incrementSimulationStep({...simParams, orientation: orientation});
  };

  return (
    <>
      <div 
        className="left" 
        id="dragzone" 
        onMouseDown={dragStart}
        onTouchStart={dragStart}
        onMouseMove={dragHandler} 
        onTouchMove={dragHandler}
        onMouseUp={dragEnd}
        onTouchEnd={dragEnd}
      >
        <div className="helper_overlay">
          <div className="bubble explanations" id="bubble_explanations">
          </div>
          <OrientationHelperLegend className="helper_legend"/>
          <OrientationHelper className="helper"/>
          <div className="bubble orientation" id="bubble_orientation">
            <div className="inner">
              Votre orientation
              <span id="txt_orientation">Sud</span>
            </div>
          </div>
        </div>
        <Map
          zoom={21}
          tilt={0}
          mapTypeId={'satellite'}
          center={simParams.adjustedLocation}
          gestureHandling={'none'}
          disableDefaultUI={true}
          controlled={true}>
        </Map>
      </div>
      <div className="right">
        <div className="text">
          <h2>Quelle est 🔍 l’orientation ?</h2>
          <span>Faites pivoter le cercle de manière à ce que la ligne au centre du cercle suive le faîtage de votre toit pour nous permettre de déterminer l’orientation exacte de vos futurs panneaux solaires et d’optimiser leur rendement.</span>
        </div>
        <Button 
          IconAfter={IconArrow} 
          variant={interacted ? '' : 'outlined thin light'} 
          link={interacted ? '/simulateur/surface' : null}
          onclick={validateOrientation}
        >Valider mon orientation</Button>
      </div>
    </>
  )
}

export default OrientationStep;